import { useMemo, useState } from 'react';

const DEFAULT_ISSUE_TYPES_IN_VIEW = 3;

const useIssueTypesList = ({ issueTypes }) => {
  const [sliceCount, setSliceCount] = useState(DEFAULT_ISSUE_TYPES_IN_VIEW);

  const showMore = () => setSliceCount(issueTypes.length);

  const showLess = () => setSliceCount(DEFAULT_ISSUE_TYPES_IN_VIEW);

  const shouldShowMore = issueTypes?.length > DEFAULT_ISSUE_TYPES_IN_VIEW;

  const issueTypesInView = useMemo(
    () => issueTypes.slice(0, sliceCount),
    [issueTypes, sliceCount]
  );

  return {
    issueTypesInView,
    shouldShowMore,
    showMore,
    showLess
  };
};

export default useIssueTypesList;
